import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const MainTheme = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: '{green.900}',
          hoverColor: '{green.700}',
        },
      },
      dark: {
        primary: {
          color: '{green.600}',
          hoverColor: '{green.700}',
        },
      },
    },
  },
  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            help: {
              background: '#BAA77D',
              hoverBackground: '#A89668',
              activeBackground: '#8A7A54',
              borderColor: '#BAA77D',
              hoverBorderColor: '#A89668',
              activeBorderColor: '#8A7A54',
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff',
            },
          },
        },
        dark: {
          root: {
            help: {
              background: '#BAA77D',
              hoverBackground: '#A89668',
              activeBackground: '#8A7A54',
              borderColor: '#BAA77D',
              hoverBorderColor: '#A89668',
              activeBorderColor: '#8A7A54',
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff',
            },
          },
        },
      },
    },
  },
});
